module.exports = __webpack_public_path__ + "static/media/Rubeus Hagrid 3.cd79afb6.jpg";